<template>

    <aside class="login-aside">

        <header>
            <a href="#" class="link-home" @click.prevent="goHome()"><icon name="logo" viewBox="0 0 115 22" /></a>

            <span>
                <router-link :to="$onduro.switchLanguage('de')">DE</router-link> | <router-link :to="$onduro.switchLanguage('nl')">NL</router-link> | <router-link :to="$onduro.switchLanguage('en')">EN</router-link>
            </span>
        </header>

        <footer>

            <a :href="'https://www.onduro.com' + $onduro.route('terms', null, locale)" target="_blank">
                {{ $t('route.terms.name') }}
            </a>

            <a :href="'https://www.onduro.com' + $onduro.route('privacy', null, locale)" target="_blank">
                {{ $t('route.privacy.name') }}
            </a>

            <a :href="'https://www.onduro.com' + $onduro.route('contact', null, locale)" v-if="!mobile">
                {{ $t('route.contact.name') }}
            </a>

            <br>

            <a href="https://www.onduro.com" v-if="!mobile">www.onduro.com</a>
        </footer>

    </aside>

</template>

<script>
export default
{
    name: 'Login-aside',

    data() {
        return {}
    },

    computed:
    {
        locale()
        {
            let lang = this.$store.state.current.locale;

            // there's no translation for English yet
            return (lang == 'en') ? 'nl' : lang;
        },

        mobile()
        {
            return location.hostname.match('mobile') ? true : false;
        }
    },

    methods:
    {
        goHome()
        {
            // click / tap on logo forces hard reload
            window.location.href = this.$onduro.route('login');
        },
    }
}
</script>



// WEBPACK FOOTER //
// LoginAside.vue?4f174ba9